import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flag-rule mb-4"><span /><span /><span /></div>
          <h3 className="font-serif text-2xl font-bold mb-3">Friends of Linda Burke</h3>
          <p className="text-primary-foreground/80 max-w-md leading-relaxed" data-testid="footer-disclaimer">
            Working together for South Lebanon's future. Re-Elect Mayor Linda Burke — Proven leadership, strong community, and a bright future for every resident.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-sm uppercase tracking-[0.2em] mb-4 text-primary-foreground/70">
            Navigate
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/meet-linda" className="hover:text-accent transition-colors">Meet Linda</Link></li>
            <li><Link to="/achievements" className="hover:text-accent transition-colors">Achievements</Link></li>
            <li><Link to="/priorities" className="hover:text-accent transition-colors">Priorities</Link></li>
            <li><Link to="/news" className="hover:text-accent transition-colors">News</Link></li>
            <li><Link to="/volunteer" className="hover:text-accent transition-colors">Volunteer</Link></li>
            <li><Link to="/donate" className="hover:text-accent transition-colors">Donate</Link></li>
          </ul>
        </div>

        <div data-testid="footer-contact-info">
          <h4 className="font-serif text-sm uppercase tracking-[0.2em] mb-4 text-primary-foreground/70">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-primary-foreground/90">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 shrink-0" /> South Lebanon, OH</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-1 shrink-0" /> lsburke4455@aol.com</li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-1 shrink-0" /> (513) 280-0929</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-foreground/15">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-primary-foreground/70">
          <p>© {new Date().getFullYear()} Friends of Linda Burke. All rights reserved.</p>
          <p className="max-w-xl">
            Paid for by Friends of Linda Burke, Donald E. Burke Jr., Treasurer.
          </p>
        </div>
      </div>
    </footer>
  );
}
